const TOKEN_KEY = 'omw_admin_token';

function getApiBase() {
  const base = process.env.REACT_APP_API_BASE || process.env.REACT_APP_AUTH_API_BASE || '';
  return String(base).replace(/\/$/, '');
}

export function getAuthBaseUrl() {
  return getApiBase();
}

export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

function authHeaders() {
  const token = getToken();
  const h = { 'Content-Type': 'application/json' };
  if (token) h.Authorization = `Bearer ${token}`;
  return h;
}

export function isAppAdmin(user) {
  return String(user?.userRole || '').toLowerCase() === 'admin';
}

export async function login(identifier, password) {
  const base = getApiBase();
  if (!base) return { success: false, error: 'REACT_APP_API_BASE not configured' };
  try {
    const id = identifier.trim();
    const res = await fetch(`${base}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username: id, identifier: id, password }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) return { success: false, error: data.error || 'Login failed' };
    return { success: true, user: data.user, token: data.token };
  } catch (e) {
    return { success: false, error: e instanceof Error ? e.message : 'Network error' };
  }
}

export async function me() {
  const base = getApiBase();
  if (!base || !getToken()) return { error: 'Not logged in' };
  try {
    const res = await fetch(`${base}/api/auth/me`, { headers: authHeaders() });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) return { error: data.error || 'Not logged in' };
    return { user: data.user };
  } catch (e) {
    return { error: e instanceof Error ? e.message : 'Network error' };
  }
}

export { authHeaders };
